
<div class="flex-box" fillComponentParentView="fillComponentParentView">
  <div class="flex-heading" #headingView>
    <div class="col-xs-12 list-header">
      <div class="pull-left">
        <span class="pR10">Orders <span *ngIf="count > 0 && this.stage !== 'CONSULTATION_CREATED'" class="text-primary">({{count}})</span></span>
        <button class="btn btn-sm btn-primary ml-3" *ngIf="(userRoles.includes('adminDoctor') || userRoles.includes('admin')) && this.stage !== 'CONSULTATION_CREATED'" (click)="fetchOrderCount()" title="Refresh Order Count">
          <i class="fa fa-refresh"></i> Refresh Count
        </button>
        <filter class="dib ml-3" [input]="filterConfig" [defaultFilter]="dropdownFilter" (apply)="applyFilter($event)"></filter>
      </div>
      <div class="pull-right"><i class="fa fa-plus-square-o mr-3 pointer" routerLink="new"></i></div>
    </div>
  </div>
  <div class="flex-content">
    <div class="list-view">
      <div class="list-sidebar">
        <div class="header">
          <div class="title">Filters</div>
          <button class="btn-xxs btn-secondary" (click)="resetFilters()">Reset</button>
        </div>
        <div class="content p-0">
          <div class="flex px-3">
            <label class="mr-3">Auto Refresh</label>
            <label data-testid="auto-refresh-switch" class="i-switch i-switch-sm bg-success">
              <input type="checkbox" [(ngModel)]="autoRefresh" (ngModelChange)="toggleAutoRefresh()" name="autoRefresh"/><i></i>
            </label>
          </div>
          <div class="flex px-3">
            <label class="mr-3">Partial Order</label>
            <label class="i-switch i-switch-sm bg-success">
              <input type="checkbox" [(ngModel)]="partialOrder" (ngModelChange)="reset()" name="partialOrder"/><i></i>
            </label>
          </div>
          <div class="flex px-3" *ngIf="this.changingApprovalDoctorList.length">
            <button class="btn-xxs btn-secondary" (click)="openAllocatedDoctorDialog()">Edit Allocation</button>
            <button data-testid="clear-reallocation" class="btn-xxs btn-secondary ml-3" (click)="clearAllSelectedApprovals()">Clear</button>
          </div>
          <div class="px-3 bdr-top" *ngIf="this.allocatedTeam === apiClientConstant.Order.AllocatedTeam.DERMATOLOGIST || isAdmin()">
            <collapse [title]="this.appConfig.Shared.ListSideBar.Types.INTERNAL_TEAMS" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.DOCTOR" [showList]="true">
              <internal-team-filter (updatedInternalTeamList)="updatedInternalTeamList($event)" [reset]="resetInternalTeamFilter" [type]="'DERMAT_TEAM'"></internal-team-filter>
            </collapse>
          </div>
          <div class="px-3 bdr-top">
            <collapse [title]="this.appConfig.Shared.ListSideBar.Types.LANGUAGES" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.LANGUAGES">
              <language-filter (updatedLanguageList)="updateLanguageFilter($event)" [reset]="resetLanguageFilter"></language-filter>
            </collapse>
          </div>
          <div class="px-3 bdr-top" *ngIf="userRoles.includes('adminDoctor')">
            <collapse [title]="this.appConfig.Shared.ListSideBar.Types.DOCTOR" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.DOCTOR">
              <doctor-filter (updatedDoctorList)="updateDoctorFilter($event)" [reset]="resetDoctorFilter" [filter]="{ userType: this.allocatedTeam || apiClientConstant.User.UserType.DERMATOLOGIST }"></doctor-filter>
            </collapse>
          </div>
          <div class="px-3 bdr-top" *ngIf="userRoles.includes('adminDoctor')">
            <collapse title="Type" [iconClass]="this.appConfig.Shared.ListSideBar.Icons.DOCTOR" [showList]="true">
              <button class="btn-xs bdr-rad-15 mr-2 mb-2 text-lwr" (click)="toggleAllocatedTeamSelection(apiClientConstant.Order.AllocatedTeam.DERMATOLOGIST)" [ngClass]="{'btn-primary': allocatedTeam == apiClientConstant.Order.AllocatedTeam.DERMATOLOGIST, 'btn-primary-outline': allocatedTeam != apiClientConstant.Order.AllocatedTeam.DERMATOLOGIST }">dermatologist</button>
              <button class="btn-xs bdr-rad-15 mr-2 mb-2 text-lwr" (click)="toggleAllocatedTeamSelection(apiClientConstant.Order.AllocatedTeam.MBBS)" [ngClass]="{'btn-primary': allocatedTeam == apiClientConstant.Order.AllocatedTeam.MBBS, 'btn-primary-outline': allocatedTeam != apiClientConstant.Order.AllocatedTeam.MBBS }">mbbs</button>
            </collapse>
          </div>
        </div>
      </div>
      <div class="list-content">
        <ag-grid-angular class="ag-theme-balham" style="height: 100%;" [columnDefs]="columnDefs" [components]="components" [rowBuffer]="0" [rowModelType]="ui.grid.rowModelType" [paginationPageSize]="ui.grid.pageSize" [cacheBlockSize]="ui.grid.pageSize" [cacheOverflowSize]="1" [maxConcurrentDatasourceRequests]="1" [infiniteInitialRowCount]="1" [maxBlocksInCache]="10" (gridReady)="onGridReady($event)"></ag-grid-angular>
      </div>
    </div>
  </div>
</div>
